'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <main style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Hero */}
      <section
        style={{
          backgroundColor: '#003c82',
          padding: '80px 24px 60px',
        }}
      >
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <p style={{ fontSize: '12px', fontWeight: '600', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#6dcff6', marginBottom: '16px' }}>
            Legal
          </p>
          <h1 style={{ fontSize: '42px', fontWeight: '700', color: '#ffffff', margin: 0, lineHeight: 1.15 }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.65)', marginTop: '16px', marginBottom: 0 }}>
            Last updated: April 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ padding: '72px 24px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <PolicySection title="Introduction">
            Brickwell Housing (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard information when you visit our website at brickwellhousing.com or interact with our services.
          </PolicySection>

          <PolicySection title="Information We Collect">
            We may collect information you provide directly to us, such as when you submit an inquiry, apply for a position, or contact us. This may include your name, email address, phone number, mailing address, and any other information you choose to provide. We also automatically collect certain technical information when you visit our site, including IP address, browser type, pages viewed, and referring URLs.
          </PolicySection>

          <PolicySection title="How We Use Your Information">
            We use the information we collect to respond to your inquiries and requests, process employment applications, improve our website and services, send you updates or communications you have requested, comply with legal obligations, and protect the rights and safety of Brickwell Housing and our users.
          </PolicySection>

          <PolicySection title="Sharing of Information">
            We do not sell or rent your personal information to third parties. We may share your information with service providers who assist us in operating our website and conducting our business, subject to confidentiality agreements. We may also disclose information when required by law or to protect our legal rights.
          </PolicySection>

          <PolicySection title="Cookies and Tracking Technologies">
            Our website may use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors are coming from. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, some portions of our site may not function properly without cookies.
          </PolicySection>

          <PolicySection title="Data Retention">
            We retain personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
          </PolicySection>

          <PolicySection title="Your Rights">
            Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, or delete the data we hold about you. To exercise any of these rights, please contact us using the information below.
          </PolicySection>

          <PolicySection title="Security">
            We implement reasonable administrative, technical, and physical safeguards to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet is completely secure.
          </PolicySection>

          <PolicySection title="Third-Party Links">
            Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites and encourage you to review their privacy policies.
          </PolicySection>

          <PolicySection title="Changes to This Policy">
            We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page with an updated effective date.
          </PolicySection>

          <PolicySection title="Contact Us">
            If you have questions or concerns about this Privacy Policy, please contact us at:<br /><br />
            <strong>Brickwell Housing</strong><br />
            Email: <a href="mailto:info@brickwellhousing.com" style={{ color: '#003c82', textDecoration: 'none' }}>info@brickwellhousing.com</a>
          </PolicySection>
        </div>
      </section>

      <Footer />
    </main>
  );
}

function PolicySection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <h2 style={{
        fontSize: '20px',
        fontWeight: '700',
        color: '#003c82',
        marginBottom: '14px',
        marginTop: 0,
        paddingBottom: '10px',
        borderBottom: '2px solid #e8f0fb',
      }}>
        {title}
      </h2>
      <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#444444', margin: 0 }}>
        {children}
      </p>
    </div>
  );
}
